import { Head } from "@inertiajs/react"

import Navbar from "@/components/ttt/Navbar"
import Footer from "@/components/ttt/Footer"
import StoreCatalog from "@/components/ttt/StoreCatalog"
import type {
  TttChrome,
  TttCardItem,
  TttCardI18n,
  TttLibraryContent,
} from "@/components/ttt/types"
import type {
  Category,
  SortOption,
  FilterState,
  CatalogLabels,
} from "@/components/storefront/types"

interface Props {
  chrome: TttChrome
  labels: CatalogLabels
  urls: { root: string; store: string }
  categories: Category[]
  items: TttCardItem[]
  filters: FilterState
  sort_options: SortOption[]
  i18n: TttCardI18n
  holiday: boolean
  holiday_sentence: string | null
  library: boolean
  library_url: string | null
  library_content: TttLibraryContent
}

export default function Store({
  chrome,
  labels,
  urls,
  categories,
  items,
  filters,
  sort_options,
  i18n,
  holiday,
  holiday_sentence,
  library,
  library_url,
  library_content,
}: Props) {
  return (
    <>
      <Head>
        <title>Boutique — TTT</title>
      </Head>

      <Navbar chrome={chrome} />

      <StoreCatalog
        labels={labels}
        urls={urls}
        categories={categories}
        items={items}
        filters={filters}
        sortOptions={sort_options}
        i18n={i18n}
        holiday={holiday}
        holidaySentence={holiday_sentence}
        backpackSrc={chrome.images.backpack}
        library={library}
        libraryUrl={library_url}
        libraryContent={library_content}
      />

      <Footer chrome={chrome} />
    </>
  )
}
